import { SubscriptionCompetitionsContext } from "./context";
import { useEffect, useState } from "react";
import { useAppDispatch } from "../../redux/hooks";
import { CompetitionData } from "../../components/ActiveCompetitions/types";
import { getUserSubscriptionPlan } from "@/app/(general-header)/subscription/subscription-service";
import { publishModalData, publishModalProps, publishModalVisibility } from "../../redux/features/modal/modalSlice";
import SubscriptionPlansModal from "./components/subscriptionPlansModal";

const SubscriptionCompetitionsProvider = ({ children }: { children: React.ReactNode }) => {
  const dispatch = useAppDispatch();
  const [lobbyContent, setLobbyContent] = useState<SubscriptionLobbyContent>({
    pastWinnerEndDate: "",
    pastWinnerStartDate: "",
    subSubcribedHeader: { disclaimer: "", subtitle: "", title: "" },
    unsubSubcribedHeader: { perks: [], subtitle: "", title: "" },
    youveEntered: [],
  });
  const [activeTab, setActiveTab] = useState<"thisWeek" | "pastWinners" | "hallOfFame">("thisWeek");
  const [isAlreadySubscribed, setIsAlreadySubscribed] = useState(false);
  const [isLobbyContentLoading, setIsLobbyContentLoading] = useState(true);
  useEffect(() => {
    (async () => {
      try {
        const res = await getUserSubscriptionPlan();
        const response = (await res.json()) as Awaited<SubscriptionPlanUser>;
        setIsAlreadySubscribed(!!response);
      } catch (err) {
        console.error(err);
        setIsAlreadySubscribed(false);
      }
    })();
  }, []);
  const onViewPlansClick = (utm?: string) => {
    const searchParams = new URLSearchParams(location.search);
    const _utm = searchParams.get("utm_medium") || utm;
    dispatch(
      publishModalData({
        modalData: <SubscriptionPlansModal place={_utm} />,
      })
    );
    dispatch(
      publishModalProps({
        withOverlay: false,
      })
    );
    dispatch(publishModalVisibility({ isOpen: true }));
  };
  const onDetailsClick = (competition: CompetitionData) => {
    location.href = competition.PageUrl;
  };
  return (
    <SubscriptionCompetitionsContext.Provider
      value={{
        activeTab,
        setActiveTab,
        onViewPlansClick,
        onDetailsClick,
        isAlreadySubscribed,
        setLobbyContent,
        lobbyContent,
        isLobbyContentLoading,
        setIsLobbyContentLoading,
      }}>
      {children}
    </SubscriptionCompetitionsContext.Provider>
  );
};

export default SubscriptionCompetitionsProvider;
